import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { requestWorkroomList } from '../../actionCreators';
import { generateSource } from '../../../utils';
import {
  createTravelingWorkDate,
  updateTravelingWorkDate,
  deleteTravelingWorkDate,
} from 'actionCreators/traveling_work_dates';
import { EditableTable } from 'components/EditableTable';
import TravelingWorkTableRow from 'travelingWorkTableRow';
import S from './styles.scss';

const DATE_FORMAT = 'MM/DD/YYYY';
const EMPTY_TABLE = (<div className={S.emptyTable}>
  <h4>No traveling work found</h4>
</div>);

class TravelingWorkTable extends React.Component {
  state = { conflict: {}, hasConflict: false };

  componentWillMount = () => this.props.requestWorkroomList();

  getStores = () => {
    const workroomsArr = Object.values(this.props.workrooms.byId);
    const workroomStores = [];
    workroomsArr.forEach(wrkrm => wrkrm.store_with_zips.forEach(szc =>
      workroomStores.push(szc.store)));
    const storeOptions = generateSource(workroomStores);
    return storeOptions;
  }

  createTravelingWorkDate = (twd) => {
    let { parentID, parentKind } = this.props;
    if (this.props.isCrew) {
      parentID = twd.crew;
      parentKind = 'crews';
    }
    return this.props.createTravelingWorkDate(parentID, parentKind, twd);
  }

  updateTravelingWorkDate = twd => this.props.updateTravelingWorkDate(twd.id, twd);

  handleSave = (twd) => {
    const assignee = { id: twd.crew, name: '', kind: '' };
    const startDate = moment(twd.start_date, DATE_FORMAT).format();
    const endDate = moment(twd.end_date, DATE_FORMAT).format();
    const params = { assignee, ...twd, start_date: startDate, end_date: endDate };
    if (twd.id === 'new') this.createTravelingWorkDate(params);
    else this.updateTravelingWorkDate(params);
  }

  handleDelete = (twd) => {
    if (twd.id !== 'new') this.props.deleteTravelingWorkDate(twd.id);
  }

  handleModalClose = () => this.setState({ hasConflict: false });

  renderRows = () => {
    const { travelingWorkDates, crews, isCrew } = this.props;
    const storeOptions = this.getStores();
    if (travelingWorkDates.length === 0 || travelingWorkDates[0].id !== 'new') {
      travelingWorkDates.unshift({ id: 'new', start_date: '', end_date: '', traveling_stores: [], crew: '' });
    }
    return travelingWorkDates.map(twd => (<TravelingWorkTableRow
      key={twd.id}
      twd={twd}
      onSave={this.handleSave}
      onDelete={this.handleDelete}
      crews={crews}
      storeOptions={storeOptions}
      isCrew={isCrew}
    />));
  }

  render = () => (<div className={S.travelingWorkTable}>
    <EditableTable isEditable={this.props.isEditable} emptyNode={EMPTY_TABLE}>
      {this.renderRows()}
    </EditableTable>
  </div>);
}

TravelingWorkTable.propTypes = {
  crews: PropTypes.array,
  isCrew: PropTypes.bool,
  workrooms: PropTypes.object,
  isEditable: PropTypes.bool,
  travelingWorkDates: PropTypes.array, // Should we create a TravelingWorkDateType?
  parentID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  parentKind: PropTypes.string.isRequired,
  requestWorkroomList: PropTypes.func.isRequired,
  createTravelingWorkDate: PropTypes.func.isRequired,
  updateTravelingWorkDate: PropTypes.func.isRequired,
  deleteTravelingWorkDate: PropTypes.func.isRequired,
};

TravelingWorkTable.defaultProps = {
  crews: [],
  isCrew: false,
  isEditable: false,
  travelingWorkDates: [],
};

const mapStateToProps = state => ({
  workrooms: state.workrooms,
});

export default connect(
  // () => ({ }),
  mapStateToProps,
  { createTravelingWorkDate,
    updateTravelingWorkDate,
    deleteTravelingWorkDate,
    requestWorkroomList },
)(TravelingWorkTable);



// WEBPACK FOOTER //
// ./client/app/shared/components/TravelingWorkTable/index.jsx